export const locales = {
  'en-US': require('./en-US.json'),
  'zh-CN': require('./zh-CN.json'),
  'ru-RU': require('./ru-RU.json'),
};
